import { Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-messages-panel',
  standalone: true,
  imports: [DatePipe, RouterModule],
  templateUrl: './messages-panel.component.html',
  styleUrl: './messages-panel.component.scss'
})
export class MessagesPanelComponent {
  readonly message = inject(UserService).select('message');

}
